import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { seoConfig } from "./seoConfig";

const SEOHandler = () => {
  const location = useLocation();

  useEffect(() => {
    const seo = seoConfig[location.pathname] || seoConfig["/"];

    document.title = seo.title;

    const descriptionMeta = document.querySelector('meta[name="description"]');
    if (descriptionMeta) {
      descriptionMeta.setAttribute("content", seo.description);
    }

    const keywordsMeta = document.querySelector('meta[name="keywords"]');
    if (keywordsMeta) {
      keywordsMeta.setAttribute("content", seo.keywords);
    }
  }, [location.pathname]);

  return null;
};

export default SEOHandler;
